<template>
  <div class="actions-cell">
    <Button v-tooltip="$t('app.tables.trackingTable.desactivateTooltip')"  v-if="params.data.progress.activated && params.data.progress.state === 0" class="btn icon square outline-white xs primary-hover" icon="bi-pause" @click="desactivateParticipant"></Button>
    <Button v-tooltip="$t('app.tables.trackingTable.activateTooltip')" v-if="!params.data.progress.activated" class="btn icon square outline-white xs primary-hover" icon="bi-play" @click="activateParticipant"></Button>
    <Button v-tooltip="$t('app.tables.trackingTable.remindTooltip')" v-if="params.data.progress.state !== 2 && params.data.progress.activated" class="btn icon square outline-white xs primary-hover" icon="bi-arrow-clockwise" @click="remindParticipant"></Button>
    <Button v-tooltip="$t('app.tables.trackingTable.goToResultTooltip')" v-if="params.data.progress.state === 2 && params.data.progress.activated" class="btn icon square outline-white xs primary-hover" icon="bi-search" @click="goToResults"></Button>
    <VDropdown placement="left" v-if="params.data.progress.state < 1" :distance="10">
      <button class="btn icon square outline-white xs primary-hover">
        <i class="bi bi-three-dots-vertical"></i>
      </button>
      <template #popper>
        <div class="action red-color" v-close-popper @click="deleteParticipant">
          <i class="bi bi-trash" />
          <span>{{ $t('app.campaign.activatedTable.deleteTalent') }}</span>
        </div>
        <div class="action" v-close-popper @click="moveParticipant">
          <i class="bi bi-arrow-left-right" />
          <span>{{ $t("app.campaign.activatedTable.moveTalent") }}</span>
        </div>
      </template>
    </VDropdown>
  </div>
</template>

<script setup lang="ts">
import { useParticipations } from '@/queries/participant.query';
import { ParticipantRow } from '@/types/participant';
import type { ICellRendererParams } from 'ag-grid-community';
const appStore = useAppStore();

const { data: participations, isPending } = useParticipations();

const props = defineProps<{
  params: ICellRendererParams<ParticipantRow>, // injected by AG Grid, contains `data`, `api`, etc.
}>();

function desactivateParticipant() {
  (props.params as any).onDesactivate(props.params.data);
}

function activateParticipant() {
  (props.params as any).onActivate(props.params.data);
}

function deleteParticipant() {
  (props.params as any).onDelete(props.params.data);
}

function moveParticipant() {
  (props.params as any).onMove(props.params.data);
}

function remindParticipant() {
  (props.params as any).onRemind(props.params.data);
}

function goToResults() {
  if (isPending.value) return;
  const participant = participations.value?.find((p) => p.participant_id === props?.params?.data?.id);
  if (!participant) return;

  appStore.changeTab('Results');
  setTimeout(() => {
    appStore.openedCandidateResults = [participant];
    appStore.talentResultPanelIsOpen = true;
  }, 100);
}

</script>

<style lang="scss">

.actions-cell {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 4px;
  height: 100%;
}
</style>